import React, { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import "../../style/style.css";
import { useJoinNowContext } from '../../Context/joinNowContext';
import { InputAdornment } from '@mui/material';
import CrossSvg from '../../svg/crossSvg';
import axios from 'axios';


function Step1() {
  const { step, setStep,  first_name, setFirstName,last_name, setLastName, email, setEmail, phone_no, setPhoneNumber } = useJoinNowContext();
  const [errors, setErrors] = useState({
    firstName: '',
   last_name: '',
    email: '',
    phoneNumber: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    // Validate first name and last name (no numbers allowed)
    if (name === "firstName" || name === "lastName") {
      if (/\d/.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: 'Please enter a valid name (no numbers allowed).',
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: '',
        }));
      }
    }

    // Validate email format
    if (name === "email") {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!emailRegex.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: 'Please enter a valid email address.',
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: '',
        }));
      }
    }

    // Validate phone number (must be numeric)
    if (name === "phoneNumber") {
      const phoneRegex = /^\d+$/;
      if (!phoneRegex.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: 'Invalid number',
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: '',
        }));
      }
    }

    // Update the value for the appropriate field
    if (name === "firstName") {
      setFirstName(value);
    } else if (name === "lastName") {
      setLastName(value);
    } else if (name === "email") {
      setEmail(value);
    } else if (name === "phoneNumber") {
      setPhoneNumber(value);
    }
  };

  const Submit = () => {
    // Clear previous errors before making a new request (optional)
    setErrors({
      firstName: '',
     last_name: '',
      email: '',
      phoneNumber: ''
    });

    axios.post('https://portal.fitstreak.club/api/api/users/checkEmailExists', {
      email: email, // Email to check
    })
    .then((response) => {
      console.log("this is response", response.data.status);
      
      if (response.data.status === "error") {
        console.error('Error Message:', response.data.message);
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "Duplicate email. User already exists.", // Display error message in UI
        }));
        return;
      }
      // If no error, proceed to the next step
      setStep(step + 1);
    })
    .catch((error) => {
      // Handle errors gracefully, checking for network-related or other issues
      console.error('Error Message:', error.response ? error.response.data.message : error.message);

      setErrors((prevErrors) => ({
        ...prevErrors,
        email: error.response ? error.response.data.message : error.message, // Display API error or network error
      }));
    });
  };

  const handleClearField = (field: string) => {
    if (field === 'firstName') setFirstName('');
    if (field === 'lastName') setLastName('');
    if (field === 'email') setEmail('');
    if (field === 'phoneNumber') setPhoneNumber('');

    setErrors(prevErrors => ({ ...prevErrors, [field]: '' }));
  };

  const isButtonDisabled = Object.values(errors).some((error) => error !== '') || !first_name || !last_name || !email || !phone_no;

  return (
    <div className='step1 w-[90%] xxs:p-4 p-6 sm:p-10 sm:w-[500px] mt-10 mb-10 md:w-[600px]  rounded-[4px] bg-[#303030] m-auto item-center justify-center'>
      <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '100%' } }} noValidate autoComplete="on">
        <TextField
          id="standard-basic"
          name="firstName"
          label="First Name"
          variant="standard"
          value={first_name}
          onChange={handleChange}
          error={!!errors.firstName}
          helperText={errors.firstName}
          InputProps={{
            endAdornment: errors.firstName ? (
              <InputAdornment position="end">
                <CrossSvg onClick={() => handleClearField("firstName")} />
              </InputAdornment>
            ) : null
          }}
        />
        <TextField
          id="standard-basic"
          name='lastName'
          label="Last Name"
          variant="standard"
          value={last_name}
          onChange={handleChange}
          error={!!errors.last_name}
          helperText={errors.last_name}
          InputProps={{
            endAdornment: errors.last_name ? (
              <InputAdornment position="end">
                <CrossSvg onClick={() => handleClearField("lastName")} />
              </InputAdornment>
            ) : null
          }}
        />
        <TextField
          id="standard-basic"
          name='email'
          label="Email"
          variant="standard"
          value={email}
          onChange={handleChange}
          error={!!errors.email}
          helperText={errors.email}
          InputProps={{
            endAdornment: errors.email ? (
              <InputAdornment position="end">
                <CrossSvg onClick={() => handleClearField('email')} />
              </InputAdornment>
            ) : null
          }}
        />
        <TextField
          id="standard-basic"
          name='phoneNumber'
          label="Phone Number"
          variant="standard"
          value={phone_no}
          onChange={handleChange}
          error={!!errors.phoneNumber}
          helperText={errors.phoneNumber}
          InputProps={{
            endAdornment: errors.phoneNumber ? (
              <InputAdornment position="end">
                <CrossSvg onClick={() => { handleClearField('phoneNumber') }} />
              </InputAdornment>
            ) : null
          }}
        />
      </Box>

      <div className='flex w-full  h-auto justify-end'>
        <button 
          className={`${( first_name === "" ||last_name === "" || email === "" || phone_no === "") || isButtonDisabled ? "bg-inherit border border-[#4e4e4e]" : "bg-red"} py-2 px-6 xxs:text-sm w-max rounded-[5px] text-white font-bold text-base mt-10`}
          disabled={isButtonDisabled}
          onClick={Submit}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default Step1;
